import { Component, h, Host, Prop } from '@stencil/core'
import md5 from 'blueimp-md5'
import { toLower } from 'lodash-es'

import { fontSize, FontSizeType } from '../../tailwind'

@Component({
  tag: 'ui-gravatar',
})
export class Gravatar {
  @Prop() email: string
  @Prop() initials: string
  @Prop() size: FontSizeType = 'base'

  render() {
    const hash = md5(toLower(this.email).trim())
    return (
      <Host
        class={`flex overflow-hidden relative flex-grow-0`}
        style={{
          fontSize: fontSize[this.size][0] as string,
          width: fontSize[this.size][0] as string,
          height: fontSize[this.size][0] as string,
        }}
      >
        <div class='flex absolute inset-0'>
          <span
            class={`m-auto font-black uppercase text-black`}
            style={{ fontSize: '0.5em', lineHeight: '0', paddingTop: '0.05em' }}
          >
            {this.initials}
          </span>
        </div>
        <div
          class='relative w-full h-full bg-center bg-cover rounded-full'
          style={{ backgroundImage: `url(https://www.gravatar.com/avatar/${hash}?d=blank)` }}
        />
        <slot />
      </Host>
    )
  }
}
